import React from "react";
import { Skeleton, Stack } from "@mui/material";

interface TotalInputsPropsInterface {
  totalInputs: number[];
  height?: number;
}

export const SkeletonForm = ({
  totalInputs,
  height = 45,
}: TotalInputsPropsInterface) => {
  return (
    <Stack spacing={1}>
      {totalInputs.map((l) => (
        <Skeleton key={l} variant="rounded" width="100%" height={height} />
      ))}
    </Stack>
  );
};
